import { ALL_VIDEO_FILE_TYPES } from './videoInterface';

interface ILastUploadChunkl {
  loaded: number
  timeStamp: number;
}

export interface InitialState {
  isConnected: boolean;
  currentQuestion: number | null;
  file: File | null;
  signedUrl: string;
  uploadSpeed: number;
  lastUploadChunk: ILastUploadChunkl;
  videoId: string;
  videoFile: ALL_VIDEO_FILE_TYPES;
}

export const enum STATES {
  IDLE = 'idle',
  UPLOAD_CONTROLLER = 'uploadController',
  UPLOADING = 'uploading',
  GET_SIGNED_URL = 'getSignedUrl',
  UPLOAD_TO_S3 = 'uploadToS3',
  UPLOADED = 'uploaded',
  FINISHED = 'finished',
}

export const enum ACTIONS {
  SET_UPLOADED = 'setUploaded',
  CONSOLE_LOG = 'consoleLog',
  SET_CONNECTION = 'setConnection',
  SET_SIGNED_URL = 'setSignedUrl',
  SET_VIDEO_FILE = 'setVideoFile',
  INITIAL_UPLOAD_TIMESTAMP = 'initialUploadTimestamp',
  UPDATE_UPLOAD_SPEED = 'updateUploadSpeed',
  SEND_UPLOAD_PROGRESS = 'sendUploadProgress',
  UPDATE_PARENT = 'updateParent',
  SENTRY = 'sentry',
}

export const enum GUARDS {
  CAN_UPLOAD = 'canUplaod',
  IS_ASSESSMENT_QUESTION = 'isAssessmentQuestion',
}
